import * as yup from 'yup';
import { PackageSize, values } from '../../../enums';
import { ICommonMedication } from '../medication-sheet-form/IMedicationSheetForm';
import { IOrder, IOrderWithDoctorId } from './IOrder';

export const CreateMedicationOrderSchema = yup.object({
  doctorId: yup.string().required(),
  medicationId: yup.string().required(),
  residentId: yup.string().required(),
  note: yup.string().nullable(),
  order: yup.string().required(),
  packageSize: yup.mixed<PackageSize>().oneOf([...values(PackageSize)]),
});

export interface IMedicationOrder extends IOrder {
  packageSize: PackageSize;
  medication: ICommonMedication;
}

export interface IMedicationOrderWithDoctorId extends IOrderWithDoctorId {
  packageSize: PackageSize;
  medication: ICommonMedication;
}

export interface ICreateMedicationOrder
  extends Omit<
    IMedicationOrder,
    'id' | 'doctor' | 'medication' | 'orderedAt' | 'deliveredAt' | 'discriminator'
  > {
  doctorId: string;
  medicationId: string;
  residentId: string;
}
